import { Injectable } from "@angular/core";
import {
  BrandCaptionLowerThirdEntity,
  BrandCaptionLowerThirdEntityRaw
} from "@common/domain";
import { ApiService } from "@youm-front/api/data-access";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  RoomBrandCaptionLowerThirdCreateRequestDTO,
  RoomBrandCaptionLowerThirdCreateResponseDTO,
  RoomBrandCaptionLowerThirdDeleteRequestDTO,
  RoomBrandCaptionLowerThirdDeleteResponseDTO,
  RoomBrandCaptionLowerThirdUnUseRequestDTO,
  RoomBrandCaptionLowerThirdUpdateRequestDTO,
  RoomBrandCaptionLowerThirdUpdateResponseDTO,
  RoomBrandCaptionLowerThirdUseRequestDTO
} from "../dto";

@Injectable()
export class RoomBrandCaptionLowerThirdService {
  constructor(private readonly apiService: ApiService) {}

  roomBrandCaptionLowerThirdCreate(
    roomBrandCaptionLowerThirdCreateRequestDTO: RoomBrandCaptionLowerThirdCreateRequestDTO
  ): Observable<RoomBrandCaptionLowerThirdCreateResponseDTO> {
    const { roomId, brandId, caption } =
      roomBrandCaptionLowerThirdCreateRequestDTO.data;

    return this.apiService
      .post<{ caption: BrandCaptionLowerThirdEntityRaw }>(
        `rooms/${roomId}/brands/${brandId}/caption-lower-thirds`,
        { primary: caption.primary, secondary: caption.secondary }
      )
      .pipe(
        map(
          (_) =>
            new RoomBrandCaptionLowerThirdCreateResponseDTO({
              caption: new BrandCaptionLowerThirdEntity(_.caption)
            })
        )
      );
  }

  roomBrandCaptionLowerThirdDelete(
    roomBrandCaptionLowerThirdDeleteRequestDTO: RoomBrandCaptionLowerThirdDeleteRequestDTO
  ): Observable<RoomBrandCaptionLowerThirdDeleteResponseDTO> {
    const { roomId, caption } = roomBrandCaptionLowerThirdDeleteRequestDTO.data;
    const { brandId, id } = caption.value;

    return this.apiService
      .delete(`rooms/${roomId}/brands/${brandId}/caption-lower-thirds/${id}`)
      .pipe(
        map(
          () =>
            new RoomBrandCaptionLowerThirdDeleteResponseDTO({
              roomId,
              caption
            })
        )
      );
  }

  roomBrandCaptionLowerThirdUnUse(
    roomBrandCaptionLowerThirdUnUseRequestDTO: RoomBrandCaptionLowerThirdUnUseRequestDTO
  ): Observable<void> {
    const { caption, roomId } = roomBrandCaptionLowerThirdUnUseRequestDTO.data;
    const { id, brandId } = caption.value;

    return this.apiService.delete<void>(
      `rooms/${roomId}/brands/${brandId}/caption-lower-thirds/${id}/use`
    );
  }

  roomBrandCaptionLowerThirdUpdate(
    roomBrandCaptionLowerThirdUpdateRequestDTO: RoomBrandCaptionLowerThirdUpdateRequestDTO
  ): Observable<RoomBrandCaptionLowerThirdUpdateResponseDTO> {
    const { roomId, brandId, captionId, update } =
      roomBrandCaptionLowerThirdUpdateRequestDTO.data;

    return this.apiService
      .put<{
        caption: BrandCaptionLowerThirdEntityRaw;
      }>(
        `rooms/${roomId}/brands/${brandId}/caption-lower-thirds/${captionId}`,
        update
      )
      .pipe(
        map(
          (_) =>
            new RoomBrandCaptionLowerThirdUpdateResponseDTO({
              caption: new BrandCaptionLowerThirdEntity(_.caption)
            })
        )
      );
  }

  roomBrandCaptionLowerThirdUse(
    roomBrandCaptionLowerThirdUseRequestDTO: RoomBrandCaptionLowerThirdUseRequestDTO
  ): Observable<void> {
    const { caption, roomId } = roomBrandCaptionLowerThirdUseRequestDTO.data;
    const { id, brandId } = caption.value;

    return this.apiService.post<void>(
      `rooms/${roomId}/brands/${brandId}/caption-lower-thirds/${id}/use`,
      {}
    );
  }
}
